




















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Advert from '@/components/activation/Advert.vue';
import LanguageSwitch from '@/components/activation/LanguageSwitch.vue';
import EUProjectInfo from '@/components/activation/EUProjectInfo.vue';
import { authService } from '@/services/AuthService';
import { tokenService } from '@/services/TokenService';
import { registrationService } from '@/services/RegistrationService';
import userFormData from '@/store/modules/userFormData';

@Component({
  components: {
    Advert,
    LanguageSwitch,
    EUProjectInfo,
  },
})
export default class Login extends Vue {
  email: string = '';
  password: string = '';
  rememberMe: boolean = false;
  isInactive: boolean = false;
  isActiveEmailValidation: boolean = false;
  wrongEmailOrPassword: boolean = false;
  isActivePasswordValidation: boolean = false;
  isLoading: boolean = false;
  isEmailChange: boolean = false;

  @Watch('email')
  onEmailChange(email: string) {
    this.$store.commit('userFormData/setEmail', email);
  }
  @Watch('password')
  onPasswordChange(password: string) {
    this.$store.commit('userFormData/setPassword', password);
  }

  mounted() {
    this.$store.dispatch('currentWorkspace/clearState');
    this.email = this.$store.state.userFormData.email;
    this.password = this.$store.state.userFormData.password;
    if (this.$route.query.redirect && this.$route.query.redirect.indexOf('confirm-email') !== -1) {
      this.isEmailChange = true;
    }
  }

  login() {
    this.isActiveEmailValidation = true;
    this.isActivePasswordValidation = true;
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    authService
      .login(this.email, this.password, this.rememberMe)
      .then(data => {
        this.isLoading = false;
        if (!data || !data.token) {
          this.wrongEmailOrPassword = true;
        }
        tokenService.saveToken(data.token);
        this.$root.$i18n.locale = data.locale;
        localStorage.setItem('locale', data.locale);
        this.$store.commit('userFormData/setEmail', '');
        this.$store.commit('userFormData/setPassword', '');
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect as string).catch(() => {});
        } else {
          this.$router.push('/').catch(() => {});
        }
      })
      .catch(data => {
        this.isLoading = false;
        if (data && data.data && data.data.error === 'inactive') {
          this.isInactive = true;
          return;
        }
        if (data && data.status === 401) {
          this.wrongEmailOrPassword = true;
        }
      });
  }
  resendActivationEmail() {
    registrationService.resendActivationEmail(this.email).then(() => {});
  }
}
